import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation,
    inject,
} from '@angular/core';
import { NEWS_FEED_CHILD_REGISTER, NewsFeedComponent } from '../../news-feed/news-feed/news-feed.component';
import { WidgetLayoutService } from '@fi-shared/widget/widget-layout.service';
import { NewsFeedService } from '@fi-app/news-feed/news-feed.service';
import { WidgetAdministrateModel } from '@fi-app/widget/model/widget-administrate.model';
import { WidgetModel } from '@fi-app/widget/model/widget.model';
import { WidgetPlaceHolderModel } from '@fi-app/widget/model/widget-place-holder.model';
import { filter, takeUntil, Subject } from 'rxjs';
import { isDefined } from '@fi-app/shared/utils/is-defined';
import { FiSignalRHelperService } from '@fi-shared/fi-signal-r/fi-signal-r-helper.service';
import { FiOnboardingActiveDataService } from '@fi-app/fi-onboarding/fi-onboarding-active/fi-onboarding-active-data.service';

@Component({
    selector: 'fi-start-page-layout',
    templateUrl: './start-page-layout.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./start-page-layout.component.scss'],
    viewProviders: [
        {
            provide: NEWS_FEED_CHILD_REGISTER,
            useFactory: (startPageLayout: FiStartPageLayoutComponent) => {
                return startPageLayout.newsFeedChildRegister.bind(startPageLayout);
            },
            deps: [FiStartPageLayoutComponent],
        },
    ],
    standalone: false,
})
export class FiStartPageLayoutComponent implements OnInit, OnDestroy {
    @Input() disableOverlay: boolean = false;
    @Input('widgetAdministrate') widgetAdministrate: WidgetAdministrateModel;
    @Input('widgetAdministrateWidgets') widgetAdministrateWidgets: { [prop: string]: WidgetModel };

    placeholders: WidgetPlaceHolderModel[] = [];

    @Output() onHomeWhenScrolled = new EventEmitter();

    private fiOnboardingActiveDataServicee = inject(FiOnboardingActiveDataService);
    private fiSignalRHelperService = inject(FiSignalRHelperService);
    private widgetLayoutService = inject(WidgetLayoutService);
    private newsFeedService = inject(NewsFeedService);

    protected homeWhenScrolled(): void {
        this.onHomeWhenScrolled.emit();
    }

    protected LoadNewNewsItems(): void {
        this.newsFeedService.raiseLoadNewNewsFeedItems(); // we should load new items in all news feed components
    }

    childNewsFeedComponents: Array<NewsFeedComponent> = [];

    private newsFeedChildRegister(component: NewsFeedComponent): void {
        this.childNewsFeedComponents.push(component);
    }

    public ngOnInit(): void {
        this.placeholders = this.widgetLayoutService
            .getLayoutById(this.widgetAdministrate.BaseUrl)
            .Placeholders.map((number) => this.getPlaceholderByNumber(number));
    }

    private getPlaceholderByNumber(number: number): WidgetPlaceHolderModel {
        let phc = this.widgetAdministrate.PlaceHolderCollection;
        for (let i = 0; i < phc.length; i++) {
            if (phc[i].Properties.Number == number) return phc[i];
        }
    }

    private ngOnDestroy$ = new Subject<void>();
    public ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
